var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('button-click')}}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }